import { Injectable } from "@angular/core";
import { STOREBRAND_INTRA_PROD_URL, STOREBRAND_PROD_URL } from "src/app/constants/business.constants";
import { DevService } from "src/app/services/dev.service";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class KronService {
  public isInProductionURL =
    window.location.hostname === STOREBRAND_PROD_URL || window.location.hostname === STOREBRAND_INTRA_PROD_URL;
  public shouldShowKronAgreements$ = this.isInProductionURL ? of(true) : this.devService.kronAgreementsToggle$;
  constructor(private readonly devService: DevService) {}
}
